
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import VirtualServerPage from "../pages/services/virtual-server/page";
import Microsoft365Page from '../pages/services/microsoft-365/page';
import ITSupportPage from '../pages/services/it-support/page';
import AboutPage from '../pages/about/page';
import ManagedITPage from '../pages/services/managed-it/page';
import MigrationPage from '../pages/services/migration/page';
import ITConsultingPage from '../pages/services/it-consulting/page';
import PortalPage from '../pages/portal/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/services/virtual-server',
    element: <VirtualServerPage />
  },
  {
    path: '/services/microsoft-365',
    element: <Microsoft365Page />
  },
  {
    path: '/services/it-support',
    element: <ITSupportPage />
  },
  {
    path: '/services/it-consulting',
    element: <ITConsultingPage />
  },
  {
    path: '/services/managed-it',
    element: <ManagedITPage />
  },
  {
    path: '/services/migration',
    element: <MigrationPage />
  },
  {
    path: '/about',
    element: <AboutPage />
  },
  {
    path: '/portal',
    element: <PortalPage />
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
